"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { decideHashQueryScroll, shouldRepeatOnLoad } from "./hashTarget";
const INTERACTIONS = ["wheel", "touchstart", "pointerdown", "keydown"] as const;

// Landing pages only: when ad parameters follow the fragment
// (`/da?gclid=…#pricing?utm_source=…`), scroll to `#pricing` as the browser
// does for a plain `#pricing`. The URL is left as it is.
// Failure modes: tests/hash-query-scroll/failure-modes.md
export default function HashQueryScroll() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  return null;
}
function _temp2() {
  if (typeof window === "undefined") {
    return;
  }
  const navigation = window.performance?.getEntriesByType?.("navigation")[0] as PerformanceNavigationTiming | undefined;
  const id = decideHashQueryScroll({
    hash: window.location.hash,
    scrollY: window.scrollY,
    hasElement: _temp,
    navigationType: navigation?.type
  });
  if (!id) {
    return;
  }
  const jump = () => {
    document.getElementById(id)?.scrollIntoView({
      block: "start"
    });
  };
  jump();
  if (document.readyState === "complete") {
    return;
  }
  const scrolledTo = window.scrollY;
  let hasInteracted = false;
  const onInteract = () => {
    hasInteracted = true;
  };
  const onLoad = () => {
    if (shouldRepeatOnLoad({
      hasInteracted,
      scrollY: window.scrollY,
      scrolledTo
    })) {
      jump();
    }
  };
  for (const type of INTERACTIONS) {
    window.addEventListener(type, onInteract, {
      passive: true,
      once: true
    });
  }
  window.addEventListener("load", onLoad, {
    once: true
  });
  return () => {
    for (const type_0 of INTERACTIONS) {
      window.removeEventListener(type_0, onInteract);
    }
    window.removeEventListener("load", onLoad);
  };
}
function _temp(candidate) {
  return document.getElementById(candidate) !== null;
}